import { Outlet } from '@remix-run/react';
import { elementsColors } from '../../../util';
import { SideOver } from '../../components';
import { LocalThemeContextProvider } from '../../context';
import { ElementDetailViewLayoutPageCommonProps } from '../shared';

export function LiquidTermElementDetailViewLayoutPage(props: ElementDetailViewLayoutPageCommonProps) {
  return (
    <SideOver {...props} className="!px-0">
      <LocalThemeContextProvider paletteSeedColor={elementsColors['Lt']}>
        <Outlet />
      </LocalThemeContextProvider>
    </SideOver>
  );
}
